import lang from '../language';

export default {
  props: {
    /**
     * 单选模式: '123'
     * 多选模式: '123, 124, 125'
     */
    value: String,
    params: Object,
    resultFormat: Function,
    title: {
      type: String,
      default: ''
    },
    appMark: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    language: {
      type: String,
      default: 'cn'
    },
    keyField: {
      type: String,
      default: 'code'
    },
    showField: {
      type: [String, Function],
      default: 'name'
    },
    /**
     * 表格模型展示数据
     * title: [string] - 表题,
     * data: [string|function] - 展示数据
     * [
     *      {title: 'full name', data: function(row){ return row.lastName + ' ' + row.firstName; }},
     *      {title: 'age', data: 'age'},
     *      {title: 'birthday', data: function(row){ return someformat(row.birthday); }}
     * ]
     */
    tbColumns: Array,
    sort: String,
    searchField: String,
    pageSize: {
      type: Number,
      default: 10
    },
    maxSelectLimit: {
      type: Number,
      default: 0
    },
    rtl: {
      type: Boolean,
      default: false
    },
    width: Number,
    disabled: {
      type: Boolean,
      default: false
    },
    dicName: { // 字典名称
      type: String,
      default: ''
    },
    filterField: { // 过滤条件
      type: String
    },
    isSearch: {
      type: Boolean,
      default: true
    },
    dropWidth: {
      type: Number,
      default: -1
    },
    dropClass: {
      type: String,
      default: ''
    },
    dropHeight: { // 下拉内容最小高度
      type: Number,
      default: 260
    },
    clear: {
      type: Boolean,
      default: true
    },
    requestType: { // 请求类型，dic字典[字典]， loopData 获取数据循环， request 异步请求数据
      type: String,
      default: 'dic'
    },
    path: { // 请求地址
      type: String,
      default: ''
    },
    loopData: { // 循环数据
      type: Array,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      show: false,
      search: '',
      lastSearch: null,
      searchColumn: null,
      i18n: lang['cn'],
      message: '',
      highlight: -1,
      pagination: false,
      list: [],
      sortedList: null,
      picked: [],
      data: [],
      pageNumber: 1,
      totalRows: 0
    };
  },

  computed: {
    headerTitle: function headerTitle() {
      var headerStr = this.i18n.items_selected;
      var replace = function replace(val) {
        return headerStr.replace('selected_count', '<b>' + val + '</b>');
      };
      if (this.picked.length) {
        return this.multiple ? replace(this.picked.length) : this.getResults();
      } else {
        return this.title;
      }
    },
    placeholderString: function placeholderString() {
      return '请选择';
    },
    inputClasses: function inputClasses() {
      return { 'sp-input-container': true, 'sp-open': this.show, 'sp-disabled': this.disabled };
    },
    keys: function keys() {
      var _this = this;

      return this.picked.map(function (value) {
        return value[_this.keyField];
      }).join(',');
    },
    names: function names() {
      return this.picked.map(function (value) {
        return value['name'];
      }).join(',');
    }
  },
  watch: {
    value: function value(val) {
      if (val) {
        if (val !== this.keys) {

          this.initSelection();
        }
      } else {
        this.remove();
      }
      this.$emit('change', val);
    },
    data: function data() {
      // this.sortList()
      // this.populate()
      if (this.picked.length) this.picked = [];else this.initSelection();
    },
    picked: function picked(val) {
      var _this2 = this;

      if (this.message && this.maxSelectLimit && val.length < this.maxSelectLimit) this.message = '';
      this.$nextTick(function () {
        if (_this2.show) {
          _this2.adjust();
          _this2.inputFocus();
        } else {
          if (_this2.multiple) {
            // 加了条件 &&  !val.length，因为字典项会自动弹出 所以注释
            // this.$refs.drop.visible()
          }
        }
      });
      this.$emit('input', this.keys);
      this.$emit('update:text', this.names);
      this.$emit('values', this.picked.slice());
    },
    pageNumber: function pageNumber(val, oldVal) {
      if (val !== oldVal) this.populate();
    },
    disabled: function disabled(val) {

      if (val && this.show) this.close();
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/dic/mixins/data.js
// module id = 16
// module chunks = 0